var map = {
	"./dealtNoTrumps_1.svg": 2304,
	"./dealtOnly789_1.svg": 2305,
	"./dealtOnlyQueensJacks_1.svg": 2306,
	"./loseLarge0_1.svg": 2307,
	"./loseLarge30_1.svg": 2308,
	"./loseLarge60_1.svg": 2309,
	"./take0Points_1.svg": 2310,
	"./take3Aces_1.svg": 2311,
	"./winLarge120_1.svg": 2312,
	"./winLarge61_1.svg": 2313,
	"./winLarge91_1.svg": 2314,
	"./winSmall120_1.svg": 2315,
	"./winSmall60_1.svg": 2316,
	"./winSmall90_1.svg": 2317,
	"./winZoleAll_1.svg": 2318,
	"./winZoleTwoAces_1.svg": 2319
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 193;